import { LazyRoute } from '@app/components/lazy-route';
import React, { lazy } from 'react';

const Page = lazy(() => import('./billing-page'));

export const BillingPage = () => {
  return (
    <LazyRoute>
      <Page />
    </LazyRoute>
  );
};
